import CloseIcon from "@mui/icons-material/Close";

import React from "react";

import Button from "./Button";
import injectStores from "../RootStore/injectStores";
import type { RouterStore } from "stores/RouterStore";

interface CloseDialogButtonProps {
  onClose?: () => void;
  routerStore?: RouterStore;
}

/**
 * `CloseDialogButton` is a React functional component that renders a button
 * to close a dialog. It uses the `injectStores` higher-order component to
 * inject the necessary stores.
 *
 * @component
 * @param {CloseDialogButtonProps} props - The properties passed to the component.
 * @param {function} props.onClose - Optional callback function to be called when the button is clicked.
 *
 * @returns {JSX.Element} A button element with a close icon.
 */
const CloseDialogButton = injectStores(
  ({ onClose, routerStore: { closeDialog } }: CloseDialogButtonProps) => {
    return (
      <Button
        tooltip="Close"
        justIcon
        key="close"
        aria-label="Close"
        color="white"
        onClick={() => {
          console.log("closeDialog called");
          if (onClose) {
            return onClose();
          }
          return closeDialog();
        }}
      >
        <CloseIcon />
      </Button>
    );
  }
);

export default CloseDialogButton;
